var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, Grid, Card, CardContent, CardHeader, TextField, DialogContent, Dialog, DialogTitle, DialogActions, CardActions, Stack } from '@mui/material';
import { inject, observer } from 'mobx-react';
import CustomFieldsPanel from '../custom-fields/custom-fields-panel';
import ListIcon from '@mui/icons-material/List';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { hasId } from '../common/ids';
var CaseTypeCodesEditor = /** @class */ (function (_super) {
    __extends(CaseTypeCodesEditor, _super);
    function CaseTypeCodesEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFieldsEditorVisible: false
        };
        return _this;
    }
    Object.defineProperty(CaseTypeCodesEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(Card, { children: [_jsx(CardHeader, { title: _jsxs(Grid, __assign({ container: true, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true, xs: 4 }, { children: _jsx("h3", { children: "Case Type Codes" }, void 0) }), void 0), _jsx(Grid, __assign({ container: true, item: true, xs: 8, justifyContent: "flex-end" }, { children: _jsxs(Button, __assign({ variant: "outlined", onClick: function (e) { return _this.onAddClick(); } }, { children: [_jsx(AddCircleIcon, {}, void 0), "Add New"] }), void 0) }), void 0)] }), void 0) }, void 0), _jsx(CardContent, { children: _jsxs(Grid, __assign({ container: true, minHeight: "200px", alignItems: "flex-start" }, { children: [this.renderCaseTypeCodes(), this.renderCustomFieldsPanel()] }), void 0) }, void 0), _jsx(CardActions, { children: _jsxs(Stack, __assign({ direction: "row", justifyContent: "flex-end", alignItems: "flex-end", sx: { width: '100%' } }, { children: [this.renderSaveButton(), this.renderCancelButton()] }), void 0) }, void 0)] }, void 0));
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "renderCustomFieldsPanel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (this.state.isFieldsEditorVisible) {
                return (_jsxs(Dialog, __assign({ open: true, fullWidth: true, maxWidth: false, onClose: function (e, reason) { return _this.onCloseCustomFieldsEditorClick(false, reason); } }, { children: [_jsx(DialogTitle, { children: "Edit Fields" }, void 0), _jsx(DialogContent, { children: _jsx(CustomFieldsPanel, { isEditMode: true, isCaseTypeSelectorHidden: false, isAddressSelectionEnabled: true }, void 0) }, void 0), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ variant: "contained", onClick: function () { return _this.onCloseCustomFieldsEditorClick(true); } }, { children: "OK" }), void 0), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return _this.onCloseCustomFieldsEditorClick(false); } }, { children: "Cancel" }), void 0)] }, void 0)] }), void 0));
            }
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "onCloseCustomFieldsEditorClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isOk, reason) {
            var _a, _b, _c;
            if (reason === 'backdropClick')
                return;
            this.setState(__assign(__assign({}, this.state), { isFieldsEditorVisible: false }));
            if (isOk) {
                var fieldsJson = JSON.stringify((_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.fields);
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseTypeCode(__assign(__assign({}, (_c = this.props.caseTypesStore) === null || _c === void 0 ? void 0 : _c.currentCaseTypeCode), { fields: fieldsJson }));
            }
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "renderSaveButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(Button, __assign({ variant: "contained", color: "primary", onClick: function (e) { return _this.onSaveClick(); } }, { children: [_jsx(SaveIcon, {}, void 0), _jsx("span", { children: "Save" }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "renderCancelButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsx(Button, __assign({ variant: "outlined", style: { marginLeft: '15px' }, onClick: function (e) { return _this.onCancelClick(); } }, { children: "Cancel" }), void 0));
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "onSaveClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.onSaveCaseTypeCodes();
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "onCancelClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.onCancel();
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "renderCaseTypeCodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c;
            if (!((_b = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.caseTypeCodes) === null || _b === void 0 ? void 0 : _b.length)) {
                return _jsx(Stack, __assign({ flex: "1", alignItems: "center" }, { children: "No items" }), void 0);
            }
            var marginStyle = {
                marginRight: '10px'
            };
            return (_c = this.props.caseTypesStore) === null || _c === void 0 ? void 0 : _c.caseTypeCodes.map(function (c, index) {
                return (_jsxs(Grid, __assign({ container: true, style: { marginBottom: '20px' }, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _jsx(TextField, { variant: "outlined", required: true, fullWidth: true, InputLabelProps: { shrink: true }, value: c.name, onChange: function (e) { return _this.onNameChange(e, c); }, label: "Name" }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _jsx(TextField, { InputLabelProps: { shrink: true }, variant: "outlined", type: "file", inputProps: { accept: ".docx" }, fullWidth: true, onChange: function (e) { return _this.onTemplateChange(e, c); }, label: "DOCX Template" }, void 0) }), void 0), _jsxs(Grid, __assign({ item: true, xs: 4, style: marginStyle }, { children: [_jsxs(Button, __assign({ variant: "outlined", onClick: function (e) { return _this.onEditFieldsClick(c.id); } }, { children: [_jsx(ListIcon, {}, void 0), "Edit Fields"] }), void 0), _this.renderDeleteButton(c)] }), void 0)] }), index));
            });
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "renderDeleteButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (c) {
            var _this = this;
            if (hasId(c.id))
                return null;
            return (_jsxs(Button, __assign({ variant: "outlined", style: { marginLeft: '10px' }, onClick: function (e) { return _this.onRemoveClick(c.id); } }, { children: [_jsx(DeleteIcon, {}, void 0), "Delete"] }), void 0));
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "onTypeChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, caseType) {
            var _a;
            var updatedCaseType = __assign(__assign({}, caseType), { caseTypeCodeID: e.target.value });
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCaseType(updatedCaseType);
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "onNameChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, caseTypeCode) {
            var _a;
            var updatedCaseTypeCode = __assign(__assign({}, caseTypeCode), { name: e.target.value });
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCaseTypeCode(updatedCaseTypeCode);
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "onTemplateChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, caseTypeCode) {
            var _this = this;
            var _a;
            var files = e.target.files;
            if (files.length === 0) {
                var updatedCaseTypeCode = __assign(__assign({}, caseTypeCode), { exportTemplate: '' });
                (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCaseTypeCode(updatedCaseTypeCode);
                return;
            }
            var fileReader = new FileReader();
            fileReader.onload = function (evt) {
                var _a;
                var updatedCaseType = __assign(__assign({}, caseTypeCode), { exportTemplate: fileReader.result.replace('data:', '').replace(/^.+,/, '') });
                (_a = _this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCaseTypeCode(updatedCaseType);
            };
            fileReader.readAsDataURL(files[0]);
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "onAddClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.addCaseTypeCode();
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "onRemoveClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeCodeId) {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.removeCaseTypeCode(caseTypeCodeId);
        }
    });
    Object.defineProperty(CaseTypeCodesEditor.prototype, "onEditFieldsClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeId) {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.setCurrentCaseTypeCode(caseTypeId);
            this.setState(__assign(__assign({}, this.state), { isFieldsEditorVisible: true }));
        }
    });
    CaseTypeCodesEditor = __decorate([
        inject('rootStore'),
        inject('languageStore'),
        inject('caseTypesStore'),
        inject('fieldsStore'),
        observer
    ], CaseTypeCodesEditor);
    return CaseTypeCodesEditor;
}(React.Component));
export default CaseTypeCodesEditor;
